exports = module.exports = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "map-editor .table.no-border-top {\n  border-top: 2px solid var(--color-white);\n}\nmap-editor .table.no-border-top .table-label {\n  padding: 0.8rem 0 0 1rem;\n}\n", ""]);

